/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "GuardianSetAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "consistencyLevel",
                type: "uint8",
            },
        ],
        name: "LogMessagePublished",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentGuardianSetIndex",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
        ],
        name: "getGuardianSet",
        outputs: [
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGuardianSetExpiry",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "emitter",
                type: "address",
            },
        ],
        name: "nextSequence",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseAndVerifyVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct GovernanceStructs.ContractUpgrade",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseGuardianSetUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        components: [
                            {
                                internalType: "address[]",
                                name: "keys",
                                type: "address[]",
                            },
                            {
                                internalType: "uint32",
                                name: "expirationTime",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct Structs.GuardianSet",
                        name: "newGuardianSet",
                        type: "tuple",
                    },
                    {
                        internalType: "uint32",
                        name: "newGuardianSetIndex",
                        type: "uint32",
                    },
                ],
                internalType: "struct GovernanceStructs.GuardianSetUpgrade",
                name: "gsu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedSetMessageFee",
                type: "bytes",
            },
        ],
        name: "parseSetMessageFee",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "messageFee",
                        type: "uint256",
                    },
                ],
                internalType: "struct GovernanceStructs.SetMessageFee",
                name: "smf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedTransferFees",
                type: "bytes",
            },
        ],
        name: "parseTransferFees",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32",
                        name: "recipient",
                        type: "bytes32",
                    },
                ],
                internalType: "struct GovernanceStructs.TransferFees",
                name: "tf",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "parseVM",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "nonce",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                internalType: "uint8",
                name: "consistencyLevel",
                type: "uint8",
            },
        ],
        name: "publishMessage",
        outputs: [
            {
                internalType: "uint64",
                name: "sequence",
                type: "uint64",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitContractUpgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitNewGuardianSet",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitSetMessageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_vm",
                type: "bytes",
            },
        ],
        name: "submitTransferFees",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "guardianIndex",
                        type: "uint8",
                    },
                ],
                internalType: "struct Structs.Signature[]",
                name: "signatures",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address[]",
                        name: "keys",
                        type: "address[]",
                    },
                    {
                        internalType: "uint32",
                        name: "expirationTime",
                        type: "uint32",
                    },
                ],
                internalType: "struct Structs.GuardianSet",
                name: "guardianSet",
                type: "tuple",
            },
        ],
        name: "verifySignatures",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "version",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "timestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "uint32",
                        name: "nonce",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "emitterChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "bytes32",
                        name: "emitterAddress",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "sequence",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "consistencyLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "uint32",
                        name: "guardianSetIndex",
                        type: "uint32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "uint8",
                                name: "guardianIndex",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct Structs.Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "bytes32",
                        name: "hash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Structs.VM",
                name: "vm",
                type: "tuple",
            },
        ],
        name: "verifyVM",
        outputs: [
            {
                internalType: "bool",
                name: "valid",
                type: "bool",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "testNewImplementationActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
var _bytecode = "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";
var MockImplementation__factory = /** @class */ (function (_super) {
    __extends(MockImplementation__factory, _super);
    function MockImplementation__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockImplementation__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockImplementation__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockImplementation__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockImplementation__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockImplementation__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    MockImplementation__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    MockImplementation__factory.bytecode = _bytecode;
    MockImplementation__factory.abi = _abi;
    return MockImplementation__factory;
}(ContractFactory));
export { MockImplementation__factory };
